@if (!this.noLabel()) {
  <cam-badge [type]="this.color" [value]="this.label | translate"></cam-badge>
} @else {
  <cam-bullet [type]="this.color"></cam-bullet>
}
